import { ELEMENTAL_VOD_URL, LIVE_EGRESS_URL, MEDIA_STREAM_LIVE_VOD_DOMAIN, MEDIA_STREAM_LIVE_VOD_ORIGIN_APP_NAME, MEDIA_STREAM_VOD_CDN_DOMAIN, MEDIA_STREAM_VOD_ORIGIN_APP_NAME, } from "./settings";
function getHLSLiveOnDemandURL(streamName) {
    let url = 'https://';
    url += MEDIA_STREAM_LIVE_VOD_DOMAIN + '/';
    url += MEDIA_STREAM_LIVE_VOD_ORIGIN_APP_NAME + '/';
    url += streamName;
    url += '_live.json/master.m3u8';
    return url;
}
function getHLSOnDemandURL(streamName) {
    let url = 'https://';
    url += MEDIA_STREAM_VOD_CDN_DOMAIN + '/';
    url += MEDIA_STREAM_VOD_ORIGIN_APP_NAME + '/';
    url += streamName;
    url += '.json/master.m3u8';
    return url;
}
function getElementalVodUrl(streamName) {
    let url = ELEMENTAL_VOD_URL;
    url += streamName;
    url += "/vod.m3u8";
    return url;
}
function getLiveEgressUrl(streamName) {
    let url = LIVE_EGRESS_URL;
    url += streamName;
    url += '/index.m3u8';
    return url;
}
export { getHLSLiveOnDemandURL, getHLSOnDemandURL, getElementalVodUrl, getLiveEgressUrl };
//# sourceMappingURL=urls.js.map